import React from 'react';
import { useLabels, useSitemap } from 'wsm-common-data';

const FALLBACK_URL = '/locations-list.htm';
const ALL_LOCATION_LABEL_KEY = 'LIST_ALL_LOCATIONS';
const DEFAULT_LABEL = 'List all locations';

const ListAllLocationsLink = () => {
	const labels = useLabels();
	const sitemap = useSitemap();

	const linkText = labels.get(ALL_LOCATION_LABEL_KEY) || DEFAULT_LABEL;

	return (
		<a
			href={sitemap.get('LOCATIONS_LIST') || FALLBACK_URL}
			className="px-0 my-2"
		>
			{linkText}
			<i className="ddc-icon ddc-icon-arrow4-right ddc-icon-size-small ml-2" />
		</a>
	);
};

export default ListAllLocationsLink;
